import React, { PropTypes } from 'react';
import moment from 'moment';

const AuditSearchTournament = ({
  tournamentId,
  tournamentName,
  startDate,
  endDate,
  registrationCloseDate,
  onNavigationClick
}) => {
  return (
    <div className="list-group-item-labeled">
      <a className="list-group-item-labeled-child has-link"
        style={{ width: 200 }}
        onClick={() => onNavigationClick(`admin/audit/tournament/${tournamentId}`)}>
        <span>{'Tournament'}</span>
        <span>{tournamentName}</span>
      </a>
      <div className="list-group-item-labeled-child"
        style={{ width: 120 }}>
        <span>{'Start'}</span>
        <span>
          {
            startDate
              ? `${moment.parseZone(startDate).format('MMM Do, YYYY')}`
              : '-'
          }
        </span>
      </div>
      <div className="list-group-item-labeled-child"
        style={{ width: 120 }}>
        <span>{'End'}</span>
        <span>
          {
            endDate
              ? `${moment.parseZone(endDate).format('MMM Do, YYYY')}`
              : '-'
          }
        </span>
      </div>
      <div className="list-group-item-labeled-child"
        style={{ width: 120 }}>
        <span>{'Registration Close'}</span>
        <span>
          {
            registrationCloseDate
              ? `${moment.parseZone(registrationCloseDate).format('MMM Do, YYYY')}`
              : '-'
          }
        </span>
      </div>
    </div>
  );
};

AuditSearchTournament.propTypes = {
  addressBase: PropTypes.string,
  tournamentId: PropTypes.string,
  tournamentName: PropTypes.string,
  startDate: PropTypes.string,
  endDate: PropTypes.string,
  registrationCloseDate: PropTypes.string,
  onNavigationClick: PropTypes.func
};

AuditSearchTournament.defaultProps = {
};

export default AuditSearchTournament;



// WEBPACK FOOTER //
// ./src/features/admin/audit/tournamentAudit/AuditSearchTournament.jsx